// ── CANONICAL PHASE LIST — the SINGLE source of truth for phases everywhere ──────────
// Used by the field app (collection, Evaluation, Market) AND the On Air CRM (boards,
// Parking). Do NOT create divergent copies — import from here. Keys are lowercase
// p0–p6 plus px (no `phase0`-style variants).
export const PHASES = [
  ['p0', 'Planning'],
  ['p1', 'Site Prep, Demolition & Foundation'],
  ['p2', 'Framing & Structural'],
  ['p3', 'MEP & Drywall'],
  ['p4', 'Interior Finishing'],
  ['p5', 'Exterior & Landscaping'],
  ['p6', 'Go to Market'],
  ['px', 'Phase X · Not phased / spans phases / seasonal'],
];

export const PHASE_KEYS = PHASES.map(([k]) => k);
export const PHASE_LABEL = Object.fromEntries(PHASES);

// Bump this whenever the canonical list's MEANING changes. Records stamped with the
// current version are trusted; older / unstamped records are surfaced as "needs review"
// so a human re-phases them via the Market edit modal — NO destructive auto-migration.
// (The old systems reused p0–p6 keys with different meanings, so the key alone can't tell
// us whether a stored phase is correct — only the version stamp can.)
export const CANONICAL_PHASE_VERSION = 'v2';

// True only if the record was saved under the current canonical system AND carries a
// known canonical key. Legacy records (no stamp, or the retired p7 key) → review.
export const isCanonicalPhased = (rec) =>
  !!rec && rec.phaseSystem === CANONICAL_PHASE_VERSION && Object.prototype.hasOwnProperty.call(PHASE_LABEL, rec.phase);

// Human label for a phase key, falling back to the raw value.
export const phaseLabel = (key) => PHASE_LABEL[key] || key || '—';
